import { environment } from '../../environments/environment';

export const appConfig = {
  production: environment.production,
  apiUrl: environment.apiUrl,
  apiPrefix: environment.apiPreFix,
};

export const API_ENDPOINTS = {
  auth: `${appConfig.apiUrl}${appConfig.apiPrefix}/auth`,
  empresas: `${appConfig.apiUrl}${appConfig.apiPrefix}/empresa`,
  licencias: `${appConfig.apiUrl}${appConfig.apiPrefix}/licencia`,
  sucursales: `${appConfig.apiUrl}${appConfig.apiPrefix}/sucursal`,
  usuarios: `${appConfig.apiUrl}${appConfig.apiPrefix}/usuario`,
  sunat: `${appConfig.apiUrl}${appConfig.apiPrefix}/sunat`,
  telefono: `${environment.apiMicaChatUrl}${appConfig.apiPrefix}/mica-chat/telefono`,
  creditoWhatsapp: `${environment.apiMicaChatUrl}${appConfig.apiPrefix}/mica-chat/credito-whatsapp`,
};
